import {PURCHASE_ITEM_TYPES} from '../../constants/purchases';
import {SHOP_CHEST_CONFIGS} from '../../configs/chests';
import {FACTION_CONFIGS} from '../../configs/factions';
import {FACTION_UNIT_SKIN_CONFIGS} from '../../configs/factionUnitsSkins';
import {UNIT_TYPES} from '../../configs/units';
import {ALL_FACTION_SKINS, getFactionSkinIconPath} from '../../configs/factions/skins/allFactionSkins';
import {getChestIconPath} from '../inventory/getChestIconPath';
import {getFactionIconPath} from '../factions/getFactionIconPath';
import {getFactionUnitSkinIconPath} from '../factions/getFactionUnitSkinIconPath';

export function resolvePurchaseItemDisplay(itemType, itemId) {
  switch (itemType) {
    case PURCHASE_ITEM_TYPES.CHEST: {
      const chestConfig = SHOP_CHEST_CONFIGS.find((chest) => chest.id === itemId);
      return {
        name: chestConfig?.name || itemId,
        iconPath: getChestIconPath(itemId),
      };
    }
    case PURCHASE_ITEM_TYPES.FACTION: {
      const factionConfig = FACTION_CONFIGS.find((faction) => faction.id === itemId);
      return {
        name: factionConfig?.name || itemId,
        iconPath: getFactionIconPath(itemId),
      };
    }
    case PURCHASE_ITEM_TYPES.SKIN: {
      const skinConfig = ALL_FACTION_SKINS.find((skin) => skin.id === itemId);
      return {
        name: skinConfig?.name || itemId,
        iconPath: getFactionSkinIconPath(itemId),
      };
    }
    case PURCHASE_ITEM_TYPES.CRYSTALS_EXCHANGE: {
      return {
        name: 'Обмен на нумены',
        iconPath: '/img/icons/numens.png',
      };
    }
    case PURCHASE_ITEM_TYPES.UNIT_SKIN: {
      const unitSkinConfig = FACTION_UNIT_SKIN_CONFIGS.find((config) => config.id === itemId);
      const factionConfig = FACTION_CONFIGS.find((f) => f.id === unitSkinConfig?.factionId);
      const hasD20 = !factionConfig?.unitTypes || factionConfig.unitTypes.includes(UNIT_TYPES.D20.id);
      const unitTypeId = hasD20 ? UNIT_TYPES.D20.id : UNIT_TYPES.D10.id;
      return {
        name: factionConfig ? `${factionConfig.name} — образ отряда` : itemId,
        iconPath: getFactionUnitSkinIconPath(unitTypeId, unitSkinConfig?.factionId),
      };
    }
    default:
      return {name: itemId, iconPath: null};
  }
}
